import { render, staticRenderFns } from "./hqglLogisticsBaseVariety.vue?vue&type=template&id=5d06b88f&scoped=true&"
import script from "./hqglLogisticsBaseVariety.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsBaseVariety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d06b88f",
  null
  
)

export default component.exports